import C from './Constants';
import { formatCurrency } from '../../functions';
import { renderCartItem, updateTicketRow } from "./CartRenderer";
import AutoSeatButton from './AutoSeatButton';
import DeleteSeatButton from './DeleteSeatButton';

/* PUBLIC CALLBACKS:
 * 
 *   this.props.onSeatClick(data);
 *   this.props.onStateChange(this.state);
 *   
 */

export default class SeatsList {
    constructor(props) {
        this.props = props;
        this.el = $("#SeatsList-Component");

        this.button = this.el.find('.options .btn-find-tickets');
        this.ticketsHeader = this.el.find('.seat-selection .header h5 span');
        this.seatsContainer = this.el.find('.seats');
        this.borderCompensate = this.el.find('.border-compensate');

        this.section = null;
        this.sectionData = null;
        this.oitemsInSection = null;

        this.availableSeats = null;
        this.listedSeats = [];
        this.groupedSeats = [];
        this.ungroupedSeats = [];
        this.ungroupedIndex = 0;
        this.confirmedSeats = null;
        this.state = C.STATE_SEATS_GROUPED;
        this._onSeatClick = this._onSeatClick.bind(this);
        this._onToggleState = this._onToggleState.bind(this);
        this._changeUngroupedIndex = this._changeUngroupedIndex.bind(this);
        this._makeSeatListingChangeable = this._makeSeatListingChangeable.bind(this);
        this._clearUngroupedSeatingListUI = this._clearUngroupedSeatingListUI.bind(this);
        this._changeUngroupedIndex = this._changeUngroupedIndex.bind(this);

        this.ungroupCb = this.el.find('input[type=checkbox]').change(this._onToggleState);

        this.dataStorage = this.props.dataStorage;
        this.lastPickedSeat = "";
        new AutoSeatButton(this, '#autoSeatMePlease');
        new DeleteSeatButton(this, '.deleteSeat');
    }

    bind() {
        this.state = this.dataStorage.state;
        this.reloadCart();
    }

    /* PUBLIC FUNCTIONS */

    /* -----------------------------*/
    open(section) {
        this.section = section;
        this.reloadCart();
    }

    reloadCart() {
        this._updateUI();
        const seatList = $('.seats .list');
        seatList.empty();

        if (this.dataStorage == null || this.dataStorage.cart == null || this.dataStorage.cart.length === 0) {
            //show container for returning to ticketsSelect or home
            const el = document.getElementById('no-tickets-remaining-container');
            el.hidden = false;
        }



        if (this.dataStorage != null && this.dataStorage.cart != null) {
            let cartItems = this.dataStorage.cart;
            const seatSuggestion = $('.seat-suggestion');

            let eventId = parseInt(seatSuggestion.data('event-id'));

            if (!eventId || isNaN(eventId)) {
                return false;
            }


            cartItems.forEach(cartItem => updateTicketRow(cartItem));
        }



        // Case when tickets cant be group on a section
        if (this.dataStorage.showToggleUngroupCheckbox != null && !this.dataStorage.showToggleUngroupCheckbox) {
            this.state = C.STATE_SEATS_UNGROUPED;
            this.dataStorage.state = C.STATE_SEATS_UNGROUPED;
            $('.ungroup-option').hide();
        }

        this.listedSeats = $('.seats .seat');

        if (this.dataStorage.state === C.STATE_SEATS_UNGROUPED) {
            this._makeSeatListingChangeable();
            this._setNextSelection();
        } else {
            this._clearUngroupedSeatingListUI();
        }
    }

    _onSeatClick() {
        this.props.onSeatClick();
    }

    _setNextSelection() {
        let listedSeatsInDOM = $('.seats  .seat');
        listedSeatsInDOM.removeClass('next-selection no-border');
        let selIndex = this.dataStorage.GetSelectedSeatIndex();
        var nextSeat = listedSeatsInDOM[selIndex];
        $(nextSeat).addClass('next-selection')

        if (selIndex > 0) {
            $(listedSeatsInDOM[selIndex - 1]).addClass('no-border');
            this.borderCompensate.show();
        } else {
            this.borderCompensate.hide();
        }
    }

    _clearUngroupedSeatingListUI() {
        if (this.listedSeats) {
            this.listedSeats.removeClass('next-selection no-border');
            this.borderCompensate.hide();
            this.listedSeats.removeClass('changeable');
            this.listedSeats.on('click', this._changeUngroupedIndex);
        }
    }

    async _changeUngroupedIndex(e) {


        if (this.state === C.STATE_SEATS_UNGROUPED) {
            this.ungroupedIndex = $(this.listedSeats).index(e.currentTarget);
            this.dataStorage.selectedSeat = null;
            this.props.onSeatClick(this.ungroupedIndex);
            this._setNextSelection();
        }
    }

    async _handleSuccessfulRemoval() {
        await this.dataStorage.init();

        if (this.dataStorage.cart.length === 0) {
            const isSeason = JSON.parse($('.seat-suggestion').data('is-season').toLowerCase());
            window.location.href = isSeason ? "/list/seasons" : "/list/events";
            return;
        }

        const startEvent = new Event("cartUpdateEvent");
        document.dispatchEvent(startEvent);

        this.reloadCart();
        this._hideLoader();
        this.props.onStateChange(this.state);
    }

    /* When you click on a row */
    _changeUngroupedIndexLegacy(e) {

        // Select Seat
        if (this.state === C.STATE_SEATS_UNGROUPED) {
            this.ungroupedIndex = $(this.listedSeats).index(e.currentTarget);
            this.dataStorage.selectedSeat = null;
            this.props.onSeatClick(this.ungroupedIndex);
            this._setNextSelection();
        }
        return false;
    }

    _makeSeatListingChangeable() {
        this.listedSeats.on('click', this._changeUngroupedIndex);
        this.listedSeats.addClass('changeable')
    }

    _clearConfirmedSeats() {
        $('.seats .list').empty();
        this.confirmedSeats = [];
    }

    _centerSeatsContainer() {
        if (this.section.startPosition) {
            var x = this.section.startPosition.x - this.section.arenaCords.x;
            var y = this.section.startPosition.y - this.section.arenaCords.y;
            $('.section-seats').css('left', -x);
            $('.section-seats').css('top', -y);
        } else {
            let x = Math.round(($('.section-container').width() - $('.section-seats').width()) * .5);
            let y = Math.round(($('.section-container').height() - $('.section-seats').height()) * .5);

            $('.section-seats').css('left', x);
            $('.section-seats').css('top', y);
        }
    }

    _updateUI() {
        this._updateTicketButtonVisibility();
        this._updateTicketHeaderCount();
        this._updateNextArenaEventButton();
    }

    _updateTicketButtonVisibility() {
        if (!this.dataStorage.cart || !this.dataStorage.cart.length) {
            this.button.hide();
            return;
        }
        const hasUnseated = this.dataStorage.cart.some(item => item.unSeated);
        if (hasUnseated) {
            this.button.hide();
        } else {

            this.button.show();
        }
    }

    _updateTicketHeaderCount() {
        const count = this.dataStorage.cart.length || 0;
        this.ticketsHeader.text(`(${count})`);
    }

    _updateNextArenaEventButton() {
        const seatSuggestion = $('.seat-suggestion');
        const eventId = parseInt(seatSuggestion.data('event-id'));
        const isSeason = String(seatSuggestion.data('is-season')).toLowerCase() === 'true';
        const nextEventBtn = $('form[action$="NextArenaEvent"] button[type="submit"]');
        const nextEventForm = nextEventBtn.closest('form[action$="NextArenaEvent"]');

        // Early return if button/form not found
        if (!nextEventBtn.length || !nextEventForm.length) return;

        // Get and parse the event queue
        const eventQueueInput = nextEventForm.find('input[name="seatingEventQueue"]');
        let isLastEvent = true;
        if (eventQueueInput.length) {
            const val = eventQueueInput.val();
            if (val && val.trim() !== '' && val.trim() !== '[]') {
                try {
                    const eventQueue = JSON.parse(val);
                    if (Array.isArray(eventQueue) && eventQueue.length > 0) {
                        if (
                            eventQueue.length === 1 &&
                            (
                                (eventQueue[0].EventId !== undefined ? eventQueue[0].EventId : eventQueue[0].id) == eventId &&
                                String(eventQueue[0].IsSeason !== undefined ? eventQueue[0].IsSeason : eventQueue[0].isSeason).toLowerCase() === String(isSeason)
                            )
                        ) {
                            isLastEvent = true;
                        } else {
                            isLastEvent = false;
                        }
                    }
                } catch (e) {
                    // If parsing fails, treat as last event
                    isLastEvent = true;
                }
            }
        }

        if (isLastEvent) {
            nextEventForm.hide();
            return;
        } else {
            nextEventForm.show();
        }

        // Only check tickets for the current event and season
        const hasUnseated = this.dataStorage.cart &&
            this.dataStorage.cart.some(item =>
                item.unSeated &&
                item.eventId === eventId &&
                String(item.isSeason).toLowerCase() === String(isSeason)
            );
        nextEventBtn.prop('disabled', !!hasUnseated);
        if (hasUnseated) {
            nextEventBtn.attr('title', 'Alla biljetter m�ste ha platser');
            nextEventBtn.attr('aria-disabled', 'true');
        } else {
            nextEventBtn.removeAttr('title');
            nextEventBtn.removeAttr('aria-disabled');
        }
    }

    _hideLoader() {
        let loader = $('.loader');
        loader.hide();
    }

    _showLoader() {
        let loader = $('.loader');
        loader.show();
    }


    // Listener on checkbox
    _onToggleState(el) {
        var val = el.target.checked ? el.target.checked : false;
        if (val) {
            this.state = C.STATE_SEATS_UNGROUPED;
            this.dataStorage.state = C.STATE_SEATS_UNGROUPED;
            $('#choose-section-header input[type=checkbox]').prop('checked', true);
            $('#choose-seats-header input[type=checkbox]').prop('checked', true);
        } else {
            this.state = C.STATE_SEATS_GROUPED;
            this.dataStorage.state = C.STATE_SEATS_GROUPED;
            $('#choose-section-header input[type=checkbox]').prop('checked', false);
            $('#choose-seats-header input[type=checkbox]').prop('checked', false);
        }

        this._onSetState();
    }


    _onSetState() {
        if (this.dataStorage.state === C.STATE_SEATS_UNGROUPED) {
            this.state = C.STATE_SEATS_UNGROUPED;
            this.listedSeats = $('.seats .list .seat');
            this._setNextSelection();
            this._makeSeatListingChangeable();
        } else {
            this.state = C.STATE_SEATS_GROUPED;
            this.dataStorage.state = C.STATE_SEATS_GROUPED;
            this._clearUngroupedSeatingListUI();
        }

        this.props.onStateChange(this.state);
    }

    //
    // ON SELECT SEAT
    // =========================================================================== 

    _onSelectSeat(seat) {
        this.dataStorage.SetSelectedSeat(seat);
    }

    _renderCartItem(cartItem) {
        let template = $('#seat-template').html();
        template = template.replace('{{section}}', cartItem.unSeated ? '-' : cartItem.sectionName);

        let si = cartItem.seatInfo;
        if (si) {
            template = template.replace('{{seatInfo}}', si);
            template = template.replace('{{infoDisplay}}', '');
        } else {
            template = template.replace('{{infoDisplay}}', 'none');
        }

        if (cartItem.row) {
            template = template.replace('{{row}}', cartItem.unSeated ? '-' : cartItem.row);
            template = template.replace('{{hideRow}}', '');
        } else {
            template = template.replace('{{row}}', '');
            template = template.replace('{{hideRow}}', 'display:none;');
        }
        template = template.replace('{{seats}}', cartItem.unSeated ? '-' : cartItem.seatNumber);
        template = template.replace('{{price}}', cartItem.unSeated ? '-' : formatCurrency(cartItem.unitPrice + cartItem.serviceFee));

        if (cartItem.seasonConnectedToSubscription) {
            template = template.replace('{{price-col}}', 'd-none');
        }

        template = template.replace('{{type}}', cartItem.ticketName);

        let elementClass = '';
        if (this.section != null && (!this.section.oitems.includes(cartItem.id) || !cartItem.seatedTicket)) {
            elementClass = 'not-seatable';
        }
        template = template.replace('{{elementClass}}', elementClass);

        return template;
    }
}